export default __webpack_public_path__ + "static/media/ali-valencia.efb0dad1.jpg";